import { mainNum } from '../constants'

const validates = {
    mainSpareImage: {
        name: 'mainSpareImage',
        validate: {
            name: '商品主图',
            validatorNum: mainNum,
            sizeValidator: {
                minSize: 0,
                maxSize: 2
            },
            rectValidator: {
                minWidth: 600,
                minHeight: 600
            },
            ratioValidator: {
                ratio: 1 / 1
            },
            imageTypeValidator: {
                acceptTypeList: ['image/jpg', 'image/jpeg', 'image/png']
            }
        }
    },
    mainImageThreeFour: {
        name: 'mainImageThreeFour',
        accept: 'image/jpg,image/jpeg,image/png',
        validate: {
            name: '3:4主图',
            sizeValidator: {
                minSize: 0,
                maxSize: 2
            },
            rectValidator: {
                minWidth: 600,
                minHeight: 800,
                maxWidth: 5000,
                maxHeight: 5000
            },
            imageTypeValidator: {
                acceptTypeList: ['image/jpg', 'image/jpeg', 'image/png']
            },
            ratioValidator: {
                // eslint-disable-next-line no-magic-numbers
                ratio: 3 / 4
            }
        }
    },
    whiteImage: {
        name: 'whiteImage',
        validate: {
            name: '白底图',
            sizeValidator: {
                minSize: 0,
                maxSize: 2
            },
            rectValidator: {
                minWidth: 480,
                minHeight: 480
            },
            ratioValidator: {
                ratio: 1 / 1
            },
            imageTypeValidator: {
                acceptTypeList: ['image/jpg', 'image/jpeg', 'image/png']
            }
        }
    },
    transparentImage: {
        name: 'transparentImage',
        validate: {
            name: '透明图',
            sizeValidator: {
                minSize: 0,
                maxSize: 2
            },
            rectValidator: {
                minWidth: 480,
                minHeight: 480
            },
            ratioValidator: {
                ratio: 1 / 1
            },
            imageTypeValidator: {
                acceptTypeList: ['image/png']
            }
        }
    },
    itemDetailImages: {
        name: 'itemDetailImages',
        validate: {
            name: '详情图',
            sizeValidator: {
                minSize: 0,
                maxSize: 2
            },
            rectValidator: {
                maxWidth: 2000,
                maxHeight: 20000
            },
            imageTypeValidator: {
                acceptTypeList: ['image/jpg', 'image/jpeg', 'image/png']
            }
        }
    },
    goodsSku: {
        name: 'goodsSku',
        validate: {
            name: '规格图',
            sizeValidator: {
                minSize: 0,
                maxSize: 2
            },
            ratioValidator: {
                ratio: 1 / 1
            },
            imageTypeValidator: {
                acceptTypeList: ['image/jpg', 'image/jpeg', 'image/png']
            }
        }
    }
}

// 给铺货模版的配置
export const goodsQuickSets = [validates.mainSpareImage, validates.goodsSku, validates.itemDetailImages]

// 商品主图、3:4主图、
export default validates
